export function ProductIntroduction() {
  return <div className="intro"><h1>Tell us what you need to teach<span className="title-dot">.</span></h1><p>So you stay one step ahead of your students.<br />We’ll show you what 240 already has on it.</p></div>;
}
